export type YandexMapTheme = "light" | "dark";

/** Параметры виджета Яндекс.Карт (iframe map-widget, без API-ключа). */
export function buildYandexMapWidgetUrl(options: {
  lat: number;
  lon: number;
  zoom?: number;
  theme?: YandexMapTheme;
}): string {
  const { lat, lon, zoom = 17, theme } = options;
  const ll = `${lon}%2C${lat}`;
  const pt = `${lon}%2C${lat},pm2rdm`;
  const themeParam = theme === "dark" ? "&theme=dark" : "";
  return `https://yandex.ru/map-widget/v1/?ll=${ll}&z=${zoom}&pt=${pt}&lang=ru_RU${themeParam}`;
}

export function buildYandexMapBrowseUrl(options: {
  lat: number;
  lon: number;
  zoom?: number;
}): string {
  const { lat, lon, zoom = 17 } = options;
  return `https://yandex.ru/maps/?ll=${lon}%2C${lat}&z=${zoom}&pt=${lon}%2C${lat},pm2rdm`;
}
